import React, { useContext } from 'react';
import { Typography } from '@material-ui/core';
import { PatientsListingContext } from '../../context';
import { Container } from '../../components/layout/WrapperDiv';

declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

type NotFoundProps = typeof RouteProps;
export const NotFound = (props: NotFoundProps) => {
  const { appError } = useContext(PatientsListingContext);
  let status: number | undefined;
  let statusText: string | undefined;
  let type: string | undefined;
  if (appError) {
    ({ status, statusText, type } = appError);
  }

  return (
    <Container>
      {appError && statusText && (
        <Typography>
          {`Error loading ${type}: ${status} ${statusText}`}
        </Typography>
      )}
      {appError && !statusText && (
        <Typography>{`Error loading ${type}`}</Typography>
      )}
    </Container>
  );
};

export default NotFound;
